<h3>
  <span [ngClass]="color" class="badge rounded-pill">{{ role || 'N/A' }}</span>
</h3>
